import { render, staticRenderFns } from "./Landingpage.vue?vue&type=template&id=42ef11c7"
import script from "./Landingpage.vue?vue&type=script&lang=js"
export * from "./Landingpage.vue?vue&type=script&lang=js"
import style0 from "./Landingpage.vue?vue&type=style&index=0&id=42ef11c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports